import { SVGProps } from 'react';
import { ReactComponent } from 'icons/check-circle-filled.svg';

type Props = SVGProps<SVGSVGElement>;

/**
 * @deprecated Move to storybook instead
 */
export const CheckCircleFilled = (props: Props) => (
  // @ts-ignore
  <ReactComponent {...props} alt="check circle" />
);
